import Button from '@atlaskit/button';
import { Environment } from "bootstrap/environment";
import * as React from "react";
import ReactDOM from "react-dom";

export class GlobalError {

    static print(errorMessage: string): void {
        ReactDOM.render(
            <div>
                <h3>
                    We are sorry! We could not load the addin at all.
                </h3>
                <div>
                    There can be multiple causes for this - like restrictive browser settings or fast switching between add-ins or mails.
                </div>
                <div style={{ padding: "8px 0px" }}>
                    Error: {errorMessage}
                </div>
                <div>
                    {"If you cannot resolve it yourself, please create a "}
                    <a
                        href='#'
                        onClick={() => Environment.openNewWindow("https://yasoon.atlassian.net/servicedesk/customer/portal/3", "_blank")}
                    >support ticket</a>
                </div>
                <Button onClick={() => this.clearCaches()}>Clear caches</Button>
            </div>, document.getElementById('error')
        );

        return;
    }

    static clearCaches() {
        window.localStorage.clear();
    }
}
